import React from 'react';
import { 
  CssBaseline, 
  Container, 
  Typography, 
  Box,
  IconButton 
} from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { /*ThemeContextProvider, */ ColorModeContext } from '../context/ThemeContext';
import Services from '../components/Services';
import Projects from '../components/Projects';
import Contact from '../components/Contact';
import { useTheme } from '@mui/material/styles';

const HomePage = () => {
  const theme = useTheme();
  const colorMode = React.useContext(ColorModeContext);

  return (
    <>
      <CssBaseline />
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
          <IconButton onClick={colorMode.toggleColorMode} color="inherit">
            {theme.palette.mode === 'dark' ? <Brightness7 /> : <Brightness4 />}
          </IconButton>
        </Box>
        <Typography variant="h2" component="h1" gutterBottom align="center" sx={{ mt: 4 }}>
          Welcome to Techaton
        </Typography>
        <Typography variant="body1" paragraph align="center">
          Professional tech services at your fingertips.
        </Typography>
        <Services />
        <Projects />
        <Contact />
      </Container>
    </>
  );
};

export default HomePage;